(function() {
    var ContactPlanContainer = function($el) {
        this.$el = $el
        this.$contactTypeSelector = this.$el.find('.contact-type-selector')
        this.$paymentPlanSelector = this.$el.find('.payment-plan-selector')

        this.$contactTypeSelector.on('contact.change', this.togglePlanOptions.bind(this))
    
        return this
    }

    ContactPlanContainer.prototype.togglePlanOptions = function (event) {
        this.$paymentPlanSelector.trigger(event)
    }
    
    $('.contact-plan-container').each(function (event) {
        new ContactPlanContainer($(this))
    })
})()
